import $ from 'jquery';

export default class UserViewSimilar {
  constructor($scope, UserService) {
    $scope.similarity_tabs = UserService.get_similar_tabs();

    $scope.compare_tabs = UserService.get_similar_dialog_tabs();

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
      $scope.filtered_similar_users = $scope.get_filtered_similar_users(index);
    };

    $scope.set_selected_compare_tab = function(index) {
      $scope.selected_compare_tab = index;
    };

    $scope.get_filtered_similar_users_length = function(index) {
      if (index == 0)
        return $scope.similar_users.length;
      else
        return $scope.get_filtered_similar_users(index).length;
    };

    $scope.get_filtered_similar_users = function(index) {
      return UserService.get_filtered_similar_users($scope.similar_users, index);
    };

    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.compare_users = function(user) {
      $scope.compare_user = user;
      $scope.open_dialog('compare_user_dialog');
    };

    $scope.set_update_mode = function(value) {
      $scope.update_mode = value;
      $scope.updating_user = '';
    };

    $scope.mark_as_not_similar = function() {
      $scope.similar_users.splice($scope.similar_users.indexOf($scope.compare_user), 1);
      $scope.filtered_similar_users = $scope.get_filtered_similar_users($scope.selected_tab);
      $.fancybox.close();
    };

    $scope.connect_users = function() {
      $scope.updating_user = true;
      var connection = {
        user1_id: $scope.user.id,
        user2_id: $scope.compare_user.id
      };
      UserService.connect_users(connection).then(function(data) {
        if (data.success) {
          $scope.compare_user.connection = data.connection;
          $scope.updating_user = false;
        }
      });
    };

    $scope.disconnect_users = function() {
      $scope.updating_user = true;
      UserService.disconnect_users($scope.compare_user.connection.user_connection).then(function(data) {
        if (data.success) {
          $scope.compare_user.connection = null;
          $scope.updating_user = false;
        }
      });
    };

    $scope.init = function() {
      $scope.update_mode = false;
      $scope.selected_tab = 0;
      $scope.selected_compare_tab = 0;
      $scope.similar_users = window.similar_users;
      $scope.filtered_similar_users = window.similar_users;
      $scope.business_relations = window.business_relations;
      $scope.user = window.user;
    };

    $scope.init();
  }
}

UserViewSimilar.$inject = ['$scope', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-view-similar.ctrl.js